import { Component, OnInit } from '@angular/core';
import { ListDocument } from 'src/app/shared/models/signature.model';
import { DocumentBehaviorService } from 'src/app/services/behavior/document-behavior.service';
import { ToastBehaviorService } from 'src/app/services/behavior/toast-behavior.service';
import { SignatureService } from 'src/app/services/signature-service/signature.service';

declare var $:any;

@Component({
  selector: 'app-associate-subscriber',
  templateUrl: './associate-subscriber.component.html',
  styleUrls: ['./associate-subscriber.component.scss']
})

export class AssociateSubscriberComponent implements OnInit {
  
  email!: string;
  uid!: string;

  btnCheck: boolean = false;

  data: ListDocument = {"dto":[]};

  constructor(
    private readonly signatureService: SignatureService,
    private readonly toast: ToastBehaviorService,
    private readonly documentService: DocumentBehaviorService
  ) { }

  getListDocuments() {
    this.signatureService.listDocuments().subscribe((res:ListDocument) => {
      this.data = res;

    })
  }

  associateSubscriber(){
    this.signatureService.postAssociateSubscriber(this.email, this.uid).subscribe(res => {
      this.documentService.getListDocuments()
      this.toast.set('', 'Email successfully associated.', 'bg-success')
    })
  }

  subscriber(uid:string){
    this.email = "";
    this.uid = uid;
  }

  complete(uid:string){
    this.signatureService.complete(uid).subscribe(red => {
      this.documentService.getListDocuments()
      this.toast.set('', 'Group complete.', 'bg-success')
    });
  }

  ngOnInit(): void {
    this.documentService.getListDocuments()
    this.documentService.data.subscribe(data => 
      {
        this.data = data;
        this.data.dto.forEach(i => {
          if (i.subscribers.length > 0) {
            i.checkBtn = true;
          }
        })
      })
  }

}
